import React from "react";
import "./Button.css";
// import "../../common.css"
function MyButton({text,href,color,type}) {
  return (
    <a className="btn" href={href} data-color={color} data-type={type}>{text}</a>
  );
}

export default MyButton;